import { InjectionToken } from "@angular/core";

export interface NewsStateConfig {
  pageSize: number;
}

export const NEWS_STATE_CONFIG = new InjectionToken<NewsStateConfig>('NewsStateConfig');